const more_link = document.querySelector('.more-items--link a')

document.addEventListener('click', (event) => {

    if (event.target.matches('.collection-toggle')) {
        // Run your code to open a modal

        
        let targetEl = document.querySelector(`#toggle-${event.target.dataset.target}`)

        let prod_grid = document.querySelectorAll('.product-grid-toggle')

        prod_grid.forEach(node => {
            node.classList.remove('product-grid-active')
        })

        targetEl.classList.add('product-grid-active')

        more_link.href = event.target.dataset.collection
    }

})